import { tracked } from '@glimmer/tracking';

import type { SortOrderDirection } from 'webapp-types';
import { OrderDirection } from 'webapp/enums/enums';
import type { SearchProps } from 'webapp/utils/filter';

import type { Board, BoardLoop, Report } from 'webapp/models-custom';
import FilterSort from 'webapp/models-custom/filter-sort/base';

export type BoardSelectListSingleItem = Board | BoardLoop | Report;

export default class FilterSortBoardSelectListSingle extends FilterSort<BoardSelectListSingleItem> {
	@tracked override sortProp = 'name';
	@tracked override sortOrder: SortOrderDirection = OrderDirection.ASC;

	override searchProps: SearchProps = {
		name: 1,
	};
}
